import Loadable from '@loadable/component';
import GlobalContextProvider from '@/contexts/GlobalContext';

const App = Loadable(() => import('./App'));

function Index() {
  return (
    <GlobalContextProvider>
      <App />
    </GlobalContextProvider>
  );
}

export default Index;
